import { cn } from '../../lib/cn.ts';

interface ComboboxListProps {
  id: string;
  matches: string[];
  /** The index of the highlighted row, or -1 for none. */
  highlighted: number;
  optionId: (index: number) => string;
  onHighlight: (index: number) => void;
  onPick: (match: string) => void;
}

/**
 * The suggestions under the field. No padding on the popup and no rounding on
 * the rows, the same as the filter menus: a highlighted row is a filled row,
 * and an inset pill of fill leaves white wedges that read as a rendering fault.
 */
export function ComboboxList({
  id,
  matches,
  highlighted,
  optionId,
  onHighlight,
  onPick,
}: ComboboxListProps) {
  return (
    <ul
      data-slot='combobox-list'
      id={id}
      role='listbox'
      className='absolute z-50 mt-1.5 max-h-56 w-full overflow-auto rounded-md border border-line bg-surface shadow-menu animate-pop'
    >
      {matches.map((match, index) => (
        <li
          key={match}
          id={optionId(index)}
          role='option'
          aria-selected={index === highlighted}
          /* Keeps the focus on the input, so the click is not preceded by a blur that closes the list under it. */
          onMouseDown={(event) => event.preventDefault()}
          onMouseMove={() => onHighlight(index)}
          onClick={() => onPick(match)}
          className={cn(
            'truncate px-3.5 py-2.25 text-sm font-semibold text-ink transition-colors',
            index === highlighted && 'bg-fill',
          )}
        >
          {match}
        </li>
      ))}
    </ul>
  );
}
